if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = document.getElementById("product-stoc");
      // this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );

      // Initialized Cargo Price (weight-based)
      const el_cargoPrice = document.getElementById("product-cargoPrice");
      if (el_cargoPrice) {
        const grams = parseInt(this.dataset.variantGrams, 10) || 0;
        const cargoPrice = this.getCargoPrice(grams);
        el_cargoPrice.innerHTML = `Cost transport: <b>${cargoPrice} lei</b>`;
      }
    }


    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }
    /**
     * Get Cargo Price by variant weight (grams)
     */
    getCargoPrice(grams) {
      const kg = (Number(grams) || 0) / 1000;
      if (kg <= 0)   return 49;
      if (kg <= 10)  return 19;
      if (kg <= 30)  return 29;
      if (kg <= 75)  return 39;
      return 49;
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {

      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        if (
          window.productPriceBox
          && typeof window.productPriceBox.setSelectedVariant === 'function'
        ) {
          window.productPriceBox.setSelectedVariant(evt.detail.variant.id);
        }
        if (typeof window.reflectProductPrice === 'function') {
          window.reflectProductPrice();
        }
        if (typeof window.setEstimatedDates === 'function') {
          window.setEstimatedDates(evt.detail.variant);
        }
        if (typeof window.setCustomBuyButton === 'function') {
          window.setCustomBuyButton(evt.detail.variant);
        }
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );

        const el_cargoPrice = document.getElementById("product-cargoPrice");
        if (el_cargoPrice) {
          const grams = (inventory && inventory.grams) ? inventory.grams : 0;
          const cargoPrice = this.getCargoPrice(grams);
          el_cargoPrice.innerHTML = `Cost transport: <b>${cargoPrice} lei</b>`;
        }


      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;
      const el_countDownTimer = document.getElementById("shopify-block-hextom_sales_boost_usb_get_it_by_timer_twrgq9");


      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = 'In stoc';
          if (el_countDownTimer) {
            el_countDownTimer.classList.add("hidden");
          }
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel.includes('low')) {
          // this.inventoryNotice.innerText = theme.strings.lowStock;
          //   this.inventoryNotice.innerHTML = ` <div class="in-stock">
          //   <img src="https://adoremobila.myshopify.com/cdn/shop/t/83/assets/checkmark.svg?v=114364156706120143461703594377" alt="">
          //   In Stoc
          // </div>`;
          this.inventoryNotice.textContent = 'In stoc';
          if (el_countDownTimer) {
            el_countDownTimer.classList.remove("hidden");
          }
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          // this.inventoryNotice.innerText = theme.strings.noStock;
          this.inventoryNotice.innerText = "In stoc";
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
